'use client'

import { useEffect, useState } from 'react'
import { Navigation, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css/thumbs'
import 'swiper/css'
// import 'photoswipe/dist/photoswipe.css'
import styles from './ProductSlider1.module.css'

import { Gallery, Item } from 'react-photoswipe-gallery'
import Image from 'next/image'
import tippy from 'tippy.js'

export default function ProductSlider1({ images, skuImage, onClearSkuImage }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [viewerIndex, setViewerIndex] = useState(null)

  useEffect(() => {
    tippy('[data-tippy-content]')
  }, [])

  useEffect(() => {
    const target = document.getElementById('scrollFollowWrap')
    const sticky = document.getElementById('leftSticky')
    const container = document.getElementById('scrollContainer')

    if (!target || !sticky || !container) return

    // 取得 header 高度
    const getHeaderHeight = () => {
      const topBar = document.querySelector('.header-top')
      const deskBar = document.querySelector('.header-desk')
      return (topBar?.offsetHeight || 0) + (deskBar?.offsetHeight || 0)
    }

    const onScroll = () => {
      const headerH = getHeaderHeight()
      const stickyRect = sticky.getBoundingClientRect()
      const containerHeight = container.offsetHeight
      const targetHeight = target.offsetHeight

      // 🟦 slider 開始移動的位置（header 推動效果）
      const startMove = headerH

      // 左側 sticky 的 top 距離
      const offsetTop = stickyRect.top

      // 🟧 內部移動距離
      const move = Math.max(0, startMove - offsetTop)

      // 🟥 計算最大不能超過多少
      const maxMove = containerHeight - targetHeight

      // 最終限制
      const limited = Math.min(move, maxMove)

      target.style.transform = `translateY(${limited}px)`
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <>
      {/* 主圖 */}
      <div
        className={`${styles.sliderWrap} product-single__media vertical-thumbnail product-media-initialized`}
      >
        <div
          className={`${styles.mainImage} product-single__image position-relative`}
        >
          {skuImage && (
            <div className={styles.skuOverlay}>
              <Image
                src={skuImage}
                width={700}
                height={700}
                className="w-100 h-auto"
                alt="sku"
              />
            </div>
          )}
          <Swiper
            modules={[Thumbs, Navigation]}
            slidesPerView={1}
            thumbs={{ swiper: thumbsSwiper }}
            navigation={{ prevEl: '.ssnbp1', nextEl: '.ssnbn1' }}
            className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
          >
            {images.map((elm, i) => (
              <SwiperSlide
                style={{
                  maxWidth: '100%',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                key={i}
                className="swiper-slide product-single__image-item"
              >
                <Image
                  loading="lazy"
                  className="h-auto w-100"
                  src={elm.Name}
                  width={400}
                  height={400}
                  alt="image"
                  onClick={() => setViewerIndex(i)} // ✅ 點圖片也能開
                  style={{ cursor: 'zoom-in' }}
                />

                {/* ✅ 放大按鈕（右上角） */}
                <button
                  type="button"
                  className={styles.zoomBtn}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setViewerIndex(i)
                  }}
                  aria-label="Zoom image"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16">
                    <use href="#icon_zoom" />
                  </svg>
                </button>
              </SwiperSlide>
            ))}

            <div className="cursor-pointer swiper-button-prev ssnbp1">
              <svg
                width="7"
                height="11"
                viewBox="0 0 7 11"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="#icon_prev_sm" />
              </svg>
            </div>
            <div className="cursor-pointer swiper-button-next ssnbn1">
              <svg
                width="7"
                height="11"
                viewBox="0 0 7 11"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="#icon_next_sm" />
              </svg>
            </div>
          </Swiper>
        </div>
        {/* 縮圖 */}
        <div className={`${styles.thumbnailList} product-single__thumbnail`}>
          <Swiper
            modules={[Thumbs]}
            direction="vertical"
            slidesPerView="auto" // ✅ 關鍵
            spaceBetween={10} // ✅ 取代 marginBottom
            watchSlidesProgress
            onSwiper={setThumbsSwiper}
            className={styles.thumbSwiper}
          >
            {images.map((elm, i) => (
              <SwiperSlide
                key={i}
                className={`swiper-slide product-single__image-item ${
                  skuImage ? styles.thumbDim : ''
                }`}
                style={{ marginBottom: '10px' }}
                onClick={() => {
                  onClearSkuImage?.()

                  // ✅ 關鍵：主動同步 Thumbs 的 index
                  thumbsSwiper?.slideTo(i)
                }}
              >
                <Image
                  loading="lazy"
                  className="h-auto"
                  src={elm.Name}
                  width="104"
                  height="104"
                  alt="image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {viewerIndex !== null && (
        <ImageViewer
          images={images}
          index={viewerIndex}
          onClose={() => setViewerIndex(null)}
          onChange={setViewerIndex}
        />
      )}
    </>
  )
}

function ImageViewer({ images, index, onClose, onChange }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className={styles.viewerOverlay} onClick={onClose}>
      <div className={styles.viewerBox} onClick={(e) => e.stopPropagation()}>
        {/* 關閉 */}
        <button className={styles.closeBtn} onClick={onClose}>
          ✕
        </button>

        <Swiper
          modules={[Navigation]}
          initialSlide={index}
          slidesPerView={1}
          navigation
          onSlideChange={(swiper) => {
            onChange(swiper.activeIndex)
          }}
          className={styles.viewerSwiper}
        >
          {images.map((img, i) => (
            <SwiperSlide key={i} className={styles.viewerSlide}>
              <Image
                src={img.Name}
                width={900}
                height={900}
                alt=""
                className={styles.viewerImage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
